import React from "react";
import styled from "styled-components";
import Burger from "./Burger";

const Nav = styled.nav`
    width: 100%;
    height: 55px;
    background: #11538a;
    color: #fff;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
    .logo{
        padding: 15px 0;
    }
`;

const NavBar = () => {
    return (
        <Nav>
            <Burger />
        </Nav>
    );
}

export default NavBar;